import AxiosRequest from 'utils/AxiosRequest';
import config from 'configuration/configuration.js';

import { enqueueSnackbar, UploadFile } from 'actions';
import { DownloadFile } from 'actions/sessionActions.js';
import { GetTemplateRequest, V1CRReportUploadRequest } from '../requests/V1CRReportRequests.js';

export const SET_FORM_STATE = 'SET_FORM_STATE';

const onSetFormState = (value) => ({
	type: SET_FORM_STATE,
	formState: value
});

export const SetFormState = (value) => (dispatch) => {
	dispatch(onSetFormState(value));
};

export const V1CRReportUploadFile = (file, userId) => async (dispatch) => {
	await UploadFile(file).then(response => {
		V1CRReportUploadRequest(response.data, userId).then(response2 => {
			dispatch(DownloadFile(response2.data));
		}).catch((error) => {
			if (error) {
				dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
			}
		});
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetTemplate = (userId) => async (dispatch) => {
	await GetTemplateRequest(userId).then(response => {
		dispatch(DownloadFile(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};
